import axios from '../axios'

const postLessonApi = async (courseId, payload) => {
  return await axios.post(`api/lms/courses/${courseId}/lessons`, payload)
}

export default postLessonApi
